<template>
  <div style="width:100%;height:100%;background:#F3F7F9;overflow-y: auto">
    <div class="category_card">
      <div class="section_title">产品类别</div>
      <div class="tab_container">
        <div 
          v-for="(item, index) in policyData" 
          :key="index"
          :class="{ 'tab_item': true, active: selected === index }"
          @click="tabClick(index)">
          {{ item.label }}
        </div>
      </div>
    </div>
    
    <div class="category_card" style="margin-top: 12px;">
      <div class="section_title">品牌类别</div>
      <div class="brand_container">
        <div 
          v-for="(brand, index) in currentBrands" 
          :key="index"
          :class="{ 'brand_item': true, active: selectedBrandIndex === index }"
          @click="brandClick(index)">
          {{ brand.label }}
        </div>
      </div>
    </div>
    
    <div class="tabitem_container">
      <div class="policy_content">
        <div v-for="(item, index) in displayedPolicy" :key="index" class="policy_item">
          <div class="policy_image">
            <img :src="item.policyImg" :alt="item.label" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProtocolNew",
  data() {
    return {
      selected: 0,
      selectedBrandIndex: 0,
      policyData: [
        {
          label: '电视',
          children: [
            {
              label: '液晶电视',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/changhongdianshi.jpg'
            }
          ]
        },
        {
          label: '空调',
          children: [
            {
              label: '家用空调',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/changhongjiayongkongtiao.jpg'
            },
            {
              label: '家用中央空调',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/changhongjiayongzhongyangkongtiao.jpg'
            }
          ]
        },
        {
          label: '冰箱',
          children: [
            {
              label: '冰箱（柜）',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/meilingbingxiang.jpg'
            },
            {
              label: '商用冷链',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/meilingshangyonglenglian.jpg'
            }
          ]
        },
        {
          label: '洗衣机',
          children: [
            {
              label: '洗衣机/干衣机',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/meilingxiyiji.jpg'
            }
          ]
        },
        {
          label: '厨卫',
          children: [
            {
              label: '长虹',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/changhongchuwei.jpg'
            },
            {
              label: '美菱',
              policyImg: 'https://apppic.mymlsoft.com/newsmarthome/service/meilingchuwei.jpg'
            }
          ]
        }
      ]
    }
  },
  computed: {
    currentBrands() {
      return this.policyData[this.selected].children || []
    },
    displayedPolicy() {
      const brands = this.currentBrands;
      if (this.selectedBrandIndex < brands.length) {
        return [brands[this.selectedBrandIndex]];
      }
      return brands;
    }
  },
  methods: {
    tabClick(index) {
      this.selected = index;
      this.selectedBrandIndex = 0;
    },
    brandClick(index) {
      this.selectedBrandIndex = index;
    }
  }
}
</script>

<style scoped>
.category_card {
  margin: 12px;
  padding: 20px 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.section_title {
  margin-bottom: 16px;
  font-size: 17px;
  font-weight: bold;
  color: #333;
  text-align: left;
}

.tab_container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.tab_item {
  padding: 6px 14px;
  font-size: 12px;
  text-align: center;
  border-radius: 18px;
  background: #F5F5F5;
  color: #000;
  margin-bottom: 5px;
  /* transition: all 0.3s ease;
  cursor: pointer; */
}

.tab_item.active {
  background: #E8F4FF;
  color: #1890FF;
}

.brand_container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.brand_item {
  padding: 6px 18px;
  font-size: 12px;
  text-align: center;
  border-radius: 18px;
  background: #F5F5F5;
  color: #333;
  /* transition: all 0.3s ease;
  cursor: pointer; */
}

.brand_item.active {
  background: #E8F4FF;
  color: #1890FF;
}

.tabitem_container {
  padding-bottom: 20px;
}

.policy_content {
  margin: 12px;
  border-radius: 12px;
}

.policy_item {
  margin-bottom: 16px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.policy_image {
  padding: 20px 16px;
  text-align: center;
}

.policy_image img {
  width: 100%;
  height: auto;
  display: block;
  /* border-radius: 12px; */
}
</style>


// WEBPACK FOOTER //
// src/components/ProtocolNew.vue